import type { TenantConfig } from '@/types/TenantConfig'

const darkBlue = '#003e51'
const lightBlue = '#007396'
const mustard = '#c69214'

export const hooverdam: TenantConfig = {
  logo: 'assets/hooverdam/static/logo.png',
  teaserImageSize: {
    width: 430,
    height: 348,
  },
  titleInsideContentColumn: true,
  themeOptions: {
    primaryColor: darkBlue,
    secondaryColor: lightBlue,
    headerBackground: darkBlue,
    headerBottomBorder: `2px solid ${mustard}`,
    logoHeight: '67px',
    headerHeight: '105px',
    cartHeaderBackgroundColor: darkBlue,
    footerBackgroundColor: darkBlue,
    footerTextColor: 'white',
  },
  componentOptions: {
    eventDetailRoute: {
      showVenue: true,
    },
    completedOrdersRoute: {
      completedImage: {
        mobile: 'assets/hooverdam/static/hoover-dam.jpg',
        desktop: 'assets/hooverdam/static/hoover-dam-wide.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-160px',
      },
    },
  },
  i18nOverrides: {
    en: {
      selectDate: {
        placeholder: '-- Choose a Date --',
      },
      reserveDateFirst: {
        selectDateLabel: 'Date',
      },
      stepperGroupTitles: {
        default: 'Tickets',
      },
      selectAvailableSession: {
        title: 'Select a Time (Pacific Time)',
      },
      checkoutRoute: {
        title: 'Pay for Your Order',
      },
    },
  },
}
